module.exports = __webpack_public_path__ + "img/pencil-paper-icon.5f9fb335.svg";